import { createAPI } from '@/request.js'
// 意见列表
export const opinionList = data => createAPI('/api/suggestion/query.mt', 'post', data)
// 处理意见
export const editOpinion = data => createAPI('/api/suggestion/deal.mt', 'post', data)
